import {
  MEDIA_INTELLIGENCE_RESULT_SOURCE,
  STANDARD_RESULT_SOURCE,
} from '../constants';
import type { ResultSource, SectionId } from '../types';
import { NLP_SECTION_ID } from '../types';

export const getResultSourceFromSectionId = (
  sectionId?: SectionId
): ResultSource => {
  return sectionId === NLP_SECTION_ID
    ? MEDIA_INTELLIGENCE_RESULT_SOURCE
    : STANDARD_RESULT_SOURCE;
};
